import { ContactFormLinkLocation } from 'app/modules/contact-form/stores/ContactFormStore';
import {
  AnswerItem,
  ChatFormItem,
  ChatItem,
  ChatItemForm,
  ChatItemKBEntry,
  ChatItemLocationResults,
  ChatItemMessage,
  ChatItemRedirect,
  ChatItemStaticImage,
  ChatItemVideo,
  ChatItemType,
  ChatItemFeedback,
} from 'app/services/chatBot';
import React from 'react';
import { FeedbackSentiment } from 'app/hooks/fetch/useFeedbackAnalytics';

import { ChatHandlerParams } from '../../types/chat';
import FormChatItem from './FormChatItem';
import KBEntryChatItem from './KBEntryChatItem';
import LocationResultsChatItem from './LocationResultsChatItem';
import MessageChatItem from './MessageChatItem';
import RedirectChatItem from './RedirectChatItem';
import RedirectToLiveChatItem from './RedirectToLiveChatItem';
import StaticImageChatItem from './StaticImageChatItem';
import VideoChatItem from './VideoChatItem';
import FeedbackChatItem from './FeedbackChatItem';

export default function ChatItemFactory({
  chatItem,
  answerItem,
  onAnswer,
  onDismiss,
  onClickContent,
  onDisplayFormItem,
  hideAvatar,
  className,
  previousUserMessage,
  shouldAnimate,
  onFeedback,
}: {
  chatItem: ChatItem;
  answerItem?: AnswerItem;
  onAnswer: (params: ChatHandlerParams) => Promise<void>;
  onDismiss: (params: ChatHandlerParams) => Promise<void>;
  onClickContent?: (e: React.MouseEvent, chatItem: ChatItemMessage, linkLocation?: ContactFormLinkLocation) => void;
  onDisplayFormItem?: (formItem: ChatFormItem, chatItem: ChatItemForm) => void;
  hideAvatar?: boolean;
  className?: string;
  previousUserMessage?: string;
  shouldAnimate?: boolean;
  onFeedback?: (feedbackSentiment: FeedbackSentiment) => void;
}) {
  switch (chatItem.type) {
    case ChatItemType.MESSAGE:
      return (
        <MessageChatItem
          chatItem={chatItem as ChatItemMessage}
          hideAvatar={hideAvatar}
          onClickContent={onClickContent}
          className={className}
        />
      );
    case ChatItemType.FORM:
      return (
        <FormChatItem
          shouldAnimate={shouldAnimate}
          className={className}
          answerItem={answerItem}
          chatItem={chatItem as ChatItemForm}
          onAnswer={onAnswer}
          onDismiss={onDismiss}
          onDisplayFormItem={onDisplayFormItem}
        />
      );
    case ChatItemType.REDIRECT_LINK:
      return <RedirectChatItem chatItem={chatItem as ChatItemRedirect} />;
    case ChatItemType.TRANSFER_TO_LIVECHAT:
      return <RedirectToLiveChatItem />;
    case ChatItemType.LOCATION_RESULTS:
      return <LocationResultsChatItem chatItem={chatItem as ChatItemLocationResults} />;
    case ChatItemType.KB_ENTRY:
      return (
        <KBEntryChatItem
          className={className}
          chatItem={chatItem as ChatItemKBEntry}
          highlightTerms={previousUserMessage}
        />
      );
    case ChatItemType.STATIC_IMAGE:
      return (
        <StaticImageChatItem
          chatItem={chatItem as ChatItemStaticImage}
          hideAvatar={hideAvatar}
          className={className}
        />
      );
    case ChatItemType.VIDEO:
      return (
        <VideoChatItem
          chatItem={chatItem as ChatItemVideo}
          hideAvatar={hideAvatar}
          className={className}
        />
      );
    case ChatItemType.FEEDBACK:
      return (
        <FeedbackChatItem
          onFeedback={onFeedback}
          chatItem={chatItem as ChatItemFeedback}
        />
      );
    default:
      return null;
  }
}
